export class Channel {
    SupplierSourceMapID: number;
    SupplierID: number;
    EntityID: number;
    Source: string;
    AllowChannelSelection: boolean;
    IsSelected: boolean;
    ActivationDate: Date;
    Sourcetype: string;
    SourcetypeID: number;
}

export class ChannelRequest {
    RequestId: number;
    FileName: string;
    IsTemplate: boolean;
    Status: string;
    SupplierComment: string;
    Feedback: string;
    RequestDate: Date;
    EDIDocumentTypeID: number;
}

export class UpdateChannelValidationRequest {
    ChannelValidationRequestID: number;
    AutoInvoiceSupplierSourceID: number;
    EDIDocumentTypeID: number;
    Status: string;
    AssignedTo: string;
    UpdatedBy: string;
    Watchers: string;
    IsArchived:boolean;
}

export class ChannelValidationRequest {
    channelValidationRequestID: number;
    supplierID: number;
    autoInvoiceSupplierSourceID: number;
    ediDocumentTypeID: number;
    status: string;
    assignedTo: string;
    createdOn: Date;
    createdBy: string;
    updatedOn: Date;
    updatedBy: string;
    sourceType: string;
    assignedToEdit: boolean;
    statusEdit: boolean;

}

export class ChannelCreateRequest {
    SupplierCode: string;
    EntityID: Array<number>;
    AutoInvoiceSupplierSourceID: number;
    EDIDocumentTypeID: number;
    CreatedBy: string;
    Comment: string;
    AdditionalFeedback: string;
    FileName: string;
    IsTeslaUser: boolean;
    FilePath: string;
    FileAsString: string;
    IsTemplate: boolean;
    CreatedOn: Date;
    TestResult: string;
}

export class SupplierChannelValidationRequest {
    ValidationRequest: ValidationRequest;
    ValidationFileInfo: Array<ValidationFileInfo>;
    ValidationRequestComment: ValidationRequestComment;
}

export class SupplierChannelValidationResponse {
    ValidationResponse: ValidationResponse;
    ValidationFileInfo: Array<ValidationFileInfo>;
    ValidationRequestComment: Array<ValidationRequestComment>;
}

export class ValidationResponse {
    ChannelValidationRequestID: number;
    AutoInvoiceSupplierSourceID: number;
    EDIDocumentTypeID: number;
    CreatedBy: string;
    CreatedOn: Date;
    SupplierID: number;
    Status: string;
    AssignedTo: string;
    Watchers: string;
}

export class ValidationRequest {
    SupplierCode: string;
    EntityID: Array<number>;
    AutoInvoiceSupplierSourceID: number;
    EDIDocumentTypeID: number;
    CreatedBy: string;
    CreatedOn: Date;
    SupplierID: number;
    Status: string;
    IsArchived: number;
    EntityName: string;
}

export class ValidationFileInfo {
    ChannelValidationRequestID: number;
    ChannelValidationFileID: number;
    FileName: string;
    FilePath: string;
    IsTemplate: boolean;
    CreatedBy: string;
    CreatedOn: Date;
    Status: string;
    IsEdit: boolean = false;
    UpdatedBy: string;
    UpdatedOn: Date;
}

export class ValidationRequestComment {
    ChannelValidationRequestID: number;
    ChannelValidationFileID: number;
    Comment: string;
    IsTeslaUser: boolean;
    CreatedBy: string;
    CreatedOn: Date;
    CreatedOnStr: string;
    IsTemplate: boolean;
    FileName: string;
}

export class Supplier {
    constructor(public SupplierCode: string, public Name: string) { }
}

export class SupplierChannelActivation {
    SupplierChannelActivationID: number;
    SupplierID: number;
    ChannelTypeID: number;
    ChannelApprovalStatusID: number;
    ApprovedByUserID: number;
    ApprovedDate: Date;
    ActivationDate: Date;
    Processed: boolean;
    CreatedOn: Date;
    CreatedBy: string;
    UpdatedOn: Date;
    UpdatedBy: string;
}


export class Watcher {
    WatcherID: number;
    TeslaWatcher: string;
    TeslaWatcherName: string;
    Enabled: boolean;
    CreatedBy: string;
    CreatedOn: Date;
    ModifiedBy: string;
    ModifiedOn: Date;
}

export class Status {
    StatusDisplay: string;
    Status: string;
}

export class AdditionalGridData {
    ChannelValidationRequestID: number;
    ChannelValidationFileID: number;
    FileName: string;
    FilePath: string;
    IsTemplate: boolean;
    CreatedBy: string;
    CreatedOn: Date;
    Status: string;
    IsEdit: boolean = false;
}

export class SupplierEDIVANInfo {
    SupplierEDIVANInfoID: number;
    SupplierCode: string;
    VANProvider: string;
    QualifierProductionID: string;
    QualifierTestID: string;
    IsAcceptedByTesla: boolean;
}

export class ChannelTemplateConfig{
    templateName: string;
    documentsConfig: TemaplateDocumentConfig[];
}

export class TemaplateDocumentConfig{
    id: string;
    fileName: string;
    documentId: string;
}


export class EdiVanInformation
{
    supplierEDIVANInfoID: number;
    supplierCode: string;
    qualifierProductionID: string;
    qualifierTestID: string;
    vanProvider: string;
    teslaContact: string;
    isAcceptedByTesla: boolean = true;
    isArchived: boolean = false;
    archivedOn: Date;
    createdOn: Date;
    createdBy: string;
    updatedOn: Date;
    updatedBy: string;
}

export class KeyValuePair {
	Key: any;
	Value: any;
}

export class RegionChannels{
    region: string;
    channels: string[];
}